/*src/plugins/installRouter.ts*/
import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import type { App } from 'vue';
export const routes: Array<RouteRecordRaw> = [];
interface Moudle {
  default: RouteRecordRaw
}

// 将modules下的全部路由配置文件加载到routes中
const moduleRouterList = import.meta.glob('pages/routers/*.ts', { eager: true });
for (const path in moduleRouterList) {
  const routerInstance = (moduleRouterList[path] as Moudle).default;
  // 自动关联routers与views 下的同名文件
  routerInstance.component = () => import(`@/pages/views/${routerInstance.name as string}.vue`);
  routes.push(routerInstance);
}

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  // Reset scroll to the top on navigation (e.g. opening a product page),
  // but restore the saved position when using the browser back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0, left: 0 };
  }
});

router.beforeResolve(async to => {
  if (to.meta.title) {
    window.document.title = to.meta.title as string;
  }
});

// The non-editor layout scrolls inside the `#vite-app` mount element (height:100%,
// overflow:auto) rather than the window, so `scrollBehavior` can't reach it.
// Drive the scroll ourselves once the new view has rendered.
function resetScrollTop() {
  const scrollers = [
    document.getElementById('vite-app'),
    document.querySelector('.main-content-area'),
    document.scrollingElement as HTMLElement | null,
  ];
  for (const el of scrollers) {
    if (el) el.scrollTop = 0;
  }
  window.scrollTo(0, 0);
}

// Scroll an in-page anchor (e.g. "Back to shop" -> "/#shop") into view. The
// target may belong to a route that is still rendering, so retry for a few
// frames until it exists. `scroll-margin-top` on the target keeps it clear of
// the sticky nav.
function scrollToHash(hash: string, attempts = 12) {
  const el = document.querySelector(hash);
  if (el) {
    el.scrollIntoView();
  } else if (attempts > 0) {
    requestAnimationFrame(() => scrollToHash(hash, attempts - 1));
  }
}

router.afterEach(to => {
  requestAnimationFrame(() => {
    if (to.hash) {
      scrollToHash(to.hash);
    } else {
      resetScrollTop();
    }
  });
});
